export default __webpack_public_path__ + "static/media/dish1.38ed4fb6.png";